import React from 'react'
import { useState } from 'react';
import { fabClasses, TextField } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import {Button} from '@mui/material';
import { margin } from '@mui/system';
import Dropzone from 'react-dropzone'
import Paper from '@mui/material/Paper'
import {Typography} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Dialog,DialogActions} from '@mui/material';
import { bulkCreateConfigJson } from '../../api';

const useStyles = makeStyles((theme) => ({
    // container:{
    //     display:"flex",
    //     height:"40vh",
    //     flexDirection:"column",
    //     alignItems:"center",
    //     justifyContent:"space-around",
    //     backgroundColor:"#EEEEEE",
    //     margin:"10px"
    // },
    largeBtn: {
        padding: 10,
        width: 140,
        margin:"0px 5px"
      },
    inputHolder:{
        display:"flex",
        width:"100%",
        //flexDirection:"column",
        alignItems:"center",
        justifyContent:"center",
        margin:"20px 0px"
    },
    paperHolder:{
      height:"250px",
      width:"800px",
      padding:"30px 0px",
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
      margin:"auto",
      borderRadius:"20px"
    },
    btnHolder:{
      margin:"20px"
    },
  //   input:{
  //     position: "absolute",
  //     left: "-99999rem"
  // },
  uploadFile: {
      border: "1px solid #ccc",
      display: "inline-block",
      padding: "6px 12px",
      cursor: "pointer"
  }

  }));

const ConfigImportJson = () => {
    const [jsonFile, setJsonFile] = useState();
    //const [jsonData,setJsonData]=useState([]);
    const [open,setOpen]=useState(false);
    const classes=useStyles();
    const handleSubmit = () => {
      if (jsonFile) {
        const reader = new FileReader();
  
        reader.onload = async function (e) {
          const text = e.target.result;
          let JsonData;
          try {
            JsonData=JSON.parse(text);
            JsonData.map((row)=>{
              try {
                row.configVal=JSON.parse(row.configVal);
              } catch (error) {}
            })
          } catch (error) {
            alert("Data in th file is not JSON");
          }
          try {
            const response=await bulkCreateConfigJson(JsonData);
            setOpen(false)
          } catch (error) {
            console.log(error)
            
          }
        };
        reader.readAsText(jsonFile);
      }
      else{
        alert("please choose a file first")
      }
    };

    const handleClose=()=>{
      setOpen(false);
    }


    
    // const onDrop = (acceptedFiles) => {
    //   // console.log(acceptedFiles);
    //   setJsonFile(acceptedFiles);
    // }
  
    return (
      // <Paper elevation={3} className={classes.paperHolder}>
      //   <Typography variant="h6" style={{fontSize: "25px",color: "rgb(89, 89, 89)",fontWeight: 700}}>Import Configs</Typography>
      //   <Paper elevation={0} className={classes.inputHolder}>
      //   <div>
      //   <input
      //       className={classes.input}
      //       type="file"
      //       accept=".json"
      //       onChange={(e) => setJsonFile(e.target.files[0])}
      //   ></input>
      //   </div>
      //   <div className={classes.btnHolder}>
      //   <Button  style={{  fontSize: "12px",
      //                     backgroundColor: "rgb(33, 218, 140)",
      //                     borderColor: "rgb(33, 218, 140)",
      //                     color: "rgb(255, 255, 255)",
      //                     borderRadius: "18px",
      //                     marginRight:"20px"
      //                     }}  variant="contained" onClick={(e) => handleSubmit(e)}>Submit</Button>
      //   </div>
      //   </Paper>
      //   <Button style={{  fontSize: "12px",
      //                     backgroundColor: "rgb(33, 218, 140)",
      //                     borderColor: "rgb(33, 218, 140)",
      //                     color: "rgb(255, 255, 255)",
      //                     borderRadius: "18px",
      //                     marginRight:"20px"
      //                     }}  variant="contained"  onClick={(e) => handleClick(e)}>Back to List</Button>
      // </Paper>
      
     <>
     <Button style={{  fontSize: "12px",
                       backgroundColor: "rgb(33, 218, 140)",
                       borderColor: "rgb(33, 218, 140)",
                       color: "rgb(255, 255, 255)",
                       borderRadius: "18px",
                       }}onClick={()=>{setOpen(true)}}>Upload File</Button>
     <Dialog open={open} aria-labelledby="form-dialog-title" className='upload'>
         <div >
         <section className="dropzone_container" style={{margin:"auto"}}>
      <div className='dropzone'>
        {/* <p style={{fontWeight: "700", fontSize: "16px", color: "#184D27"}}><span style={{textDecoration: "underline"}}>Browse</span></p> */}
        <input  type="file"
            accept=".json"
            onChange={(e) => setJsonFile(e.target.files[0])}
            />
        <p style={{fontWeight: "500", fontSize: "16px",color: "#030303", opacity: "0.5" }}>Only .json files will be allowed</p>
      </div>
      <aside>
        {/* <h4>Files</h4> */}
        {/* <ul>{files}</ul> */}
      </aside>
    </section>
         </div>
         <DialogActions style={{display:"flex",alignItems:"flex-end",left:"350px",position:"relative",paddingTop:"24px"}}>
             <Button variant="contained" onClick={handleClose}  style={{  fontSize: "12px",
                          backgroundColor: "#DDDDDD",
                          borderColor: "rgb(33, 218, 140)",
                          color: "black",
                          borderRadius: "18px",
                          marginRight:"10px",
                          padding:"8px 10px"
                      }}>
                 Cancel
             </Button>
             <Button variant="contained" onClick={handleSubmit}  style={{  fontSize: "12px",
                          backgroundColor: "rgb(33, 218, 140)",
                          borderColor: "rgb(33, 218, 140)",
                          color: "rgb(255, 255, 255)",
                          borderRadius: "18px",
                          marginRight:"10px",
                          padding:"8px 10px"
                      }}>
                 Create
             </Button>
         </DialogActions>
     </Dialog>
 </>
    );
}

export default ConfigImportJson